import type { PropsWithChildren } from 'react'
import { useSegmentedControl } from './SegmentedControl';
import clsx from 'clsx';

type SegmentedControlItemProps = PropsWithChildren<{
  value: string;
}>;

export const SegmentedControlItem = ( { children, value }: SegmentedControlItemProps ) => {
  const segmentedControl = useSegmentedControl();

  return (
    <button
      type={ 'button' }
      className={ clsx(
        'p-4 rounded-[9px] text-[#E2E8FF] text-sm font-onest font-bold flex-1 whitespace-pre',
        {
          'bg-[linear-gradient(90deg,#6739FF_0%,#6E52C3_100%)]': value === segmentedControl.value
        }
      ) }
      onClick={ () => {
        segmentedControl.setValue( value )
      } }
    >
      {children}
    </button>
  )
}
SegmentedControlItem.displayName = 'SegmentedControlItem';
